import RequestBuilder from "../RequestBuilder"
import {Method} from "../enum/Method"
import {ApiKeyJson, CreatedApiKeyJson} from "../json/ApiKeyJson"

export class ApiKeyRequests {
    static create(name: string): Promise<CreatedApiKeyJson> {
        return new RequestBuilder(Method.Post, `api-keys`)
            .withJson({name})
            .buildAndSend()
    }

    static list(): Promise<ApiKeyJson[]> {
        return new RequestBuilder(Method.Get, `api-keys`).buildAndSend()
    }

    static revoke(id: string): Promise<void> {
        return new RequestBuilder(Method.Delete, `api-keys/${id}`).buildAndSend()
    }
}
